// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__6ekXS","padding":"style_padding__5W2Pe","videoContainer":"style_videoContainer__NNzKt","closeButton":"style_closeButton__UXYJv"};